import { Injectable } from '@angular/core';

import { ApplicationAdapter } from 'application/application.adapter';
import { ModuleGraphOutput } from 'module/model/page/graph/module-graph.output';
import { ModuleGraph } from 'module/page/graph/module-graph';
import { ModuleGraphI18n } from 'module/page/graph/module-graph-i18n';
import { ModuleGraphConverterPort } from 'module/page/graph/port/module-graph-converter.port';

@Injectable()
export class ModuleGraphConverterAdapter
	extends ApplicationAdapter
	implements ModuleGraphConverterPort
{
	public asModuleGraph(output: ModuleGraphOutput): ModuleGraph {
		if (!output) {
			return null;
		}

		return new ModuleGraph(
			output.id,
			output.colors,
			output.formula,
			output.moduleId,
			output.type,
			output.updateTimestamp,
			(output.localizations || []).map(
				(loc) =>
					new ModuleGraphI18n(
						loc.title,
						loc.locale,
						loc.labels,
						loc.legends,
						loc.descriptions
					)
			)
		);
	}
}
